(() => {
  const root = document.documentElement;
  const moneyFormat = window.jkTheme?.moneyFormat || '₹{{amount}}';
  const routes = window.jkTheme?.routes || { cartAdd: '/cart/add.js', cartChange: '/cart/change.js', cartUpdate: '/cart/update.js', cart: '/cart.js', cartPage: '/cart' };
  const freeShippingThreshold = Math.max(1, Number(window.jkTheme?.freeShippingThreshold || 49900));
  const standardDeliveryAmount = Math.max(0, Number(window.jkTheme?.standardDeliveryAmount || 4900));

  const formatMoney = (cents) => {
    const amount = (Number(cents || 0) / 100).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    return moneyFormat.replace(/\{\{\s*amount(?:_no_decimals)?\s*\}\}/, amount);
  };

  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[char]));
  const productDisplayTitle = (title = '', type = '') => {
    const cleanTitle = String(title);
    return String(type).toLowerCase() === 'khakhra' && !/khakhra/i.test(cleanTitle)
      ? `${cleanTitle} Khakhra`
      : cleanTitle;
  };

  const setDrawer = (id, open) => {
    const drawer = document.getElementById(id);
    const scrim = document.querySelector(`[data-scrim-for="${id}"]`);
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    if (scrim) scrim.classList.toggle('is-open', open);
    document.body.classList.toggle('drawer-open', open);
    if (open) drawer.querySelector('button, a, input')?.focus();
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-drawer-open]');
    const closer = event.target.closest('[data-drawer-close]');
    const scrim = event.target.closest('[data-scrim-for]');
    if (opener) setDrawer(opener.dataset.drawerOpen, true);
    if (closer) setDrawer(closer.dataset.drawerClose, false);
    if (scrim) setDrawer(scrim.dataset.scrimFor, false);

    const searchOpen = event.target.closest('[data-search-open]');
    const searchClose = event.target.closest('[data-search-close]');
    if (searchOpen) {
      const panel = document.getElementById('SearchPanel');
      panel?.classList.add('is-open');
      panel?.setAttribute('aria-hidden', 'false');
      panel?.querySelector('input')?.focus();
      document.body.classList.add('drawer-open');
    }
    if (searchClose || event.target.id === 'SearchPanel') {
      const panel = document.getElementById('SearchPanel');
      panel?.classList.remove('is-open');
      panel?.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('drawer-open');
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.drawer.is-open').forEach((drawer) => setDrawer(drawer.id, false));
    document.getElementById('SearchPanel')?.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
  });

  const wishlistKey = 'jassis-kitchen-shopify-wishlist';
  const getWishlist = () => {
    try { return [...new Set(JSON.parse(localStorage.getItem(wishlistKey) || '[]'))]; }
    catch (_) { return []; }
  };
  const saveWishlist = (items) => localStorage.setItem(wishlistKey, JSON.stringify(items));
  const renderWishlistEmpty = (grid, message = 'Your wishlist is empty. Save a snack by tapping the heart icon.') => {
    grid.innerHTML = `<div class="wishlist-empty-state"><h2>No saved snacks yet</h2><p>${escapeHtml(message)}</p><a class="button button--accent button--small" href="${window.Shopify?.routes?.root || '/'}collections/all">Browse snacks</a></div>`;
  };
  const refreshWishlistUI = () => {
    const wishlist = getWishlist();
    document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
      el.textContent = wishlist.length;
      el.hidden = wishlist.length === 0;
    });
    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      const active = wishlist.includes(button.dataset.handle);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', `${active ? 'Remove' : 'Save'} ${button.dataset.title || 'product'} ${active ? 'from' : 'to'} wishlist`);
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-wishlist-toggle]');
    if (!button) return;
    event.preventDefault();
    const handle = button.dataset.handle;
    const wishlist = getWishlist();
    const isRemoving = wishlist.includes(handle);
    saveWishlist(isRemoving ? wishlist.filter((item) => item !== handle) : [...wishlist, handle]);
    if (isRemoving && button.closest('[data-wishlist-grid]')) {
      button.closest('[data-product-card]')?.remove();
      const grid = document.querySelector('[data-wishlist-grid]');
      if (grid && getWishlist().length === 0) renderWishlistEmpty(grid);
    }
    refreshWishlistUI();
  });

  const isPackingItem = (item) => item.handle === 'vacuum-packing-thepla';
  const foodItems = (cart) => cart.items.filter((item) => !isPackingItem(item));
  const foodItemCount = (cart) => foodItems(cart).reduce((total, item) => total + Number(item.quantity || 0), 0);

  const syncPackingLines = async (cart) => {
    const linkedFoods = new Map();
    cart.items.forEach((item) => {
      if (isPackingItem(item)) return;
      const group = item.properties?.['_Packing group'];
      if (group) linkedFoods.set(group, item);
    });

    const updates = {};
    cart.items.forEach((item) => {
      if (!isPackingItem(item)) return;
      const group = item.properties?.['_Packing group'];
      const food = group ? linkedFoods.get(group) : null;
      if (!food) {
        updates[item.key] = 0;
        return;
      }
      const packetsPerItem = Math.max(1, Number(item.properties?.['_Packets per item'] || food.properties?.['_Packing packets per item'] || 1));
      const requiredQuantity = Number(food.quantity || 0) * packetsPerItem;
      if (Number(item.quantity || 0) !== requiredQuantity) updates[item.key] = requiredQuantity;
    });

    if (!Object.keys(updates).length) return { cart, changed: false };
    const response = await fetch(routes.cartUpdate || '/cart/update.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });
    if (!response.ok) throw new Error('Unable to synchronise packing');
    return { cart: await response.json(), changed: true };
  };

  const updateCartCounters = (cart) => {
    const count = foodItemCount(cart);
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  };

  const renderCartDrawer = (cart) => {
    const body = document.querySelector('[data-cart-drawer-body]');
    const footer = document.querySelector('[data-cart-drawer-footer]');
    const headingCount = document.querySelector('[data-cart-heading-count]');
    const shipping = document.querySelector('[data-cart-shipping]');
    if (!body || !footer) return;
    const productCount = foodItemCount(cart);
    if (headingCount) headingCount.textContent = `${productCount} ${productCount === 1 ? 'product' : 'products'}`;
    if (!productCount) {
      body.innerHTML = '<div class="cart-drawer__empty"><span class="cart-drawer__empty-icon"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 8h14l-1 12H6L5 8Z"/><path d="M9 9V6a3 3 0 0 1 6 0v3"/></svg></span><h3>Your cart is waiting</h3><p>Add a kitchen favourite and bring a little warmth to your next tea break.</p><a class="button button--accent button--small" href="/collections/all">Explore snacks</a></div>';
      footer.hidden = true;
      if (shipping) shipping.hidden = true;
      return;
    }
    if (shipping) {
      const remaining = Math.max(0, freeShippingThreshold - cart.total_price);
      const progress = Math.min(100, Math.round((cart.total_price / freeShippingThreshold) * 100));
      shipping.hidden = false;
      shipping.classList.toggle('is-complete', remaining === 0);
      shipping.innerHTML = `<div class="cart-shipping__message">${remaining > 0 ? `Only <strong>${formatMoney(remaining)}</strong> away from free delivery` : '<strong>Free delivery unlocked!</strong>'}</div><div class="cart-shipping__track" role="progressbar" aria-label="Free delivery progress" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${progress}"><span style="width:${progress}%"></span></div>`;
    }
    body.innerHTML = cart.items.map((item) => {
      const isVacuumPackaging = isPackingItem(item);
      const packedProduct = item.properties?.['_Packing for'] || 'selected snack';
      const packedVariant = item.properties?.['_Packing variant'] || '';
      const displayTitle = isVacuumPackaging
        ? `Vacuum packing for ${packedProduct}`
        : productDisplayTitle(item.product_title, item.product_type);
      const displayVariant = isVacuumPackaging ? `${packedVariant ? `${packedVariant} · ` : ''}${item.quantity} ${item.quantity === 1 ? 'packet' : 'packets'}` : item.variant_title;
      const displayImage = isVacuumPackaging ? item.properties?.['_Packing image'] : item.image;
      const media = displayImage
        ? (isVacuumPackaging
          ? `<span class="mini-cart-item__media"><img src="${escapeHtml(displayImage)}" alt="${escapeHtml(displayTitle)}" width="88" height="88"></span>`
          : `<a class="mini-cart-item__media" href="${escapeHtml(item.url)}"><img src="${escapeHtml(displayImage)}&width=180" alt="${escapeHtml(displayTitle)}" width="88" height="88"></a>`)
        : '';
      return `
      <div class="mini-cart-item${displayImage ? '' : ' mini-cart-item--no-media'}">
        ${media}
        <div class="mini-cart-item__info">
          <h3>${isVacuumPackaging ? escapeHtml(displayTitle) : `<a href="${escapeHtml(item.url)}">${escapeHtml(displayTitle)}</a>`}</h3>
          ${displayVariant && displayVariant !== 'Default Title' ? `<p>${escapeHtml(displayVariant)}</p>` : ''}
          <div class="mini-cart-item__price">${item.original_line_price > item.final_line_price ? `<s>${formatMoney(item.original_line_price)}</s>` : ''}<strong>${formatMoney(item.final_line_price)}</strong></div>
          ${isVacuumPackaging
            ? '<p class="mini-cart-item__linked">Automatically matched to the product quantity</p>'
            : `<div class="mini-cart-item__controls" aria-label="Quantity for ${escapeHtml(displayTitle)}">
                <button type="button" data-cart-quantity data-line-key="${escapeHtml(item.key)}" data-quantity="${Math.max(0, item.quantity - 1)}" aria-label="Decrease quantity">−</button>
                <span aria-live="polite">${item.quantity}</span>
                <button type="button" data-cart-quantity data-line-key="${escapeHtml(item.key)}" data-quantity="${item.quantity + 1}" aria-label="Increase quantity">+</button>
              </div>`}
        </div>
        <button class="mini-cart-item__remove" type="button" data-cart-remove data-line-key="${escapeHtml(item.key)}" aria-label="Remove ${escapeHtml(displayTitle)} from cart"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button>
      </div>`;
    }).join('');
    footer.hidden = false;
    const noteField = footer.querySelector('[data-cart-note]');
    if (noteField && document.activeElement !== noteField) {
      const savedNote = cart.note || '';
      noteField.value = savedNote;
      noteField.dataset.savedValue = savedNote;
    }
    const productAmount = cart.items.reduce((total, item) => isPackingItem(item) ? total : total + Number(item.final_line_price || 0), 0);
    const packingAmount = cart.items.reduce((total, item) => isPackingItem(item) ? total + Number(item.final_line_price || 0) : total, 0);
    const itemCharges = productAmount + packingAmount;
    const merchandiseTotal = Number(cart.total_price || 0);
    const discountAmount = Math.max(0, itemCharges - merchandiseTotal);
    const deliveryAmount = merchandiseTotal >= freeShippingThreshold ? 0 : standardDeliveryAmount;
    const payableTotal = merchandiseTotal + deliveryAmount;
    const productValue = footer.querySelector('[data-cart-products]');
    const packingValue = footer.querySelector('[data-cart-packing]');
    const packingRow = footer.querySelector('[data-cart-packing-row]');
    const discountValue = footer.querySelector('[data-cart-discount]');
    const discountRow = footer.querySelector('[data-cart-discount-row]');
    const deliveryValue = footer.querySelector('[data-cart-delivery]');
    const totalValue = footer.querySelector('[data-cart-total]');
    if (productValue) productValue.textContent = formatMoney(productAmount);
    if (packingValue) packingValue.textContent = formatMoney(packingAmount);
    if (packingRow) packingRow.hidden = packingAmount === 0;
    if (discountValue) discountValue.textContent = `-${formatMoney(discountAmount)}`;
    if (discountRow) discountRow.hidden = discountAmount === 0;
    if (deliveryValue) deliveryValue.textContent = deliveryAmount === 0 ? 'Free' : formatMoney(deliveryAmount);
    if (totalValue) totalValue.textContent = formatMoney(payableTotal);
  };

  const fetchCart = async () => {
    const response = await fetch(routes.cart, { headers: { Accept: 'application/json' } });
    const rawCart = await response.json();
    const normalised = await syncPackingLines(rawCart);
    const cart = normalised.cart;
    if (normalised.changed && document.querySelector('.cart-page')) {
      window.location.reload();
      return cart;
    }
    updateCartCounters(cart);
    renderCartDrawer(cart);
    return cart;
  };

  let cartNoteSaveTimer;
  const saveCartNote = async (noteField) => {
    if (!noteField) return true;
    const note = noteField.value;
    const savedNote = noteField.dataset.savedValue || '';
    const status = noteField.closest('.cart-drawer__note')?.querySelector('[data-cart-note-status]');
    if (note === savedNote) return true;
    if (status) status.textContent = 'Saving…';
    noteField.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(routes.cartUpdate || '/cart/update.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ note })
      });
      if (!response.ok) throw new Error('Unable to save note');
      const changedCart = await response.json();
      const cart = (await syncPackingLines(changedCart)).cart;
      noteField.dataset.savedValue = cart.note || '';
      if (status) status.textContent = 'Saved';
      return true;
    } catch (_) {
      if (status) status.textContent = 'Could not save. Please try again.';
      return false;
    } finally {
      noteField.removeAttribute('aria-busy');
    }
  };

  document.addEventListener('input', (event) => {
    const noteField = event.target.closest('[data-cart-note]');
    if (!noteField) return;
    clearTimeout(cartNoteSaveTimer);
    const status = noteField.closest('.cart-drawer__note')?.querySelector('[data-cart-note-status]');
    if (status) status.textContent = 'Unsaved';
    cartNoteSaveTimer = setTimeout(() => saveCartNote(noteField), 700);
  });

  document.addEventListener('click', async (event) => {
    const checkout = event.target.closest('[data-cart-checkout]');
    if (!checkout) return;
    const noteField = document.querySelector('[data-cart-note]');
    if (!noteField || noteField.value === (noteField.dataset.savedValue || '')) return;
    event.preventDefault();
    clearTimeout(cartNoteSaveTimer);
    const destination = checkout.href;
    if (await saveCartNote(noteField)) window.location.assign(destination);
  });

  document.addEventListener('click', async (event) => {
    const cartControl = event.target.closest('[data-cart-remove], [data-cart-quantity]');
    if (!cartControl) return;
    event.preventDefault();
    const cartItem = cartControl.closest('.mini-cart-item');
    cartItem?.classList.add('is-updating');
    cartControl.disabled = true;
    const quantity = cartControl.hasAttribute('data-cart-remove') ? 0 : Number(cartControl.dataset.quantity);
    try {
      const response = await fetch(routes.cartChange || '/cart/change.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: cartControl.dataset.lineKey, quantity })
      });
      if (!response.ok) throw new Error('Unable to update item');
      const changedCart = await response.json();
      const cart = (await syncPackingLines(changedCart)).cart;
      updateCartCounters(cart);
      renderCartDrawer(cart);
    } catch (_) {
      cartItem?.classList.remove('is-updating');
      cartControl.disabled = false;
      cartItem?.insertAdjacentHTML('beforeend', '<span class="mini-cart-item__error">Please try again.</span>');
    }
  });

  document.addEventListener('submit', async (event) => {
    const discountForm = event.target.closest('[data-cart-discount-form]');
    if (discountForm) {
      event.preventDefault();
      const input = discountForm.querySelector('input[name="discount"]');
      const message = discountForm.querySelector('[data-cart-discount-message]');
      const checkout = document.querySelector('[data-cart-checkout]');
      const code = input?.value.trim() || '';
      if (!code) {
        if (message) message.textContent = 'Enter a discount code first.';
        input?.focus();
        return;
      }
      sessionStorage.setItem('jk-discount-code', code);
      if (checkout) checkout.href = `/discount/${encodeURIComponent(code)}?redirect=/checkout`;
      discountForm.classList.add('is-applied');
      if (message) message.textContent = 'Code saved. Shopify will verify it at checkout.';
      return;
    }
    const productForm = event.target.closest('.js-product-form');
    if (productForm) {
      event.preventDefault();
      const button = productForm.querySelector('[data-product-submit]');
      if (!button || button.disabled) return;
      const original = button.textContent;
      button.disabled = true;
      button.textContent = 'Adding…';
      try {
        const formData = new FormData(productForm);
        const productQuantity = Math.max(1, Number(formData.get('quantity') || 1));
        const productItem = { id: String(formData.get('id')), quantity: productQuantity };
        const items = [productItem];
        const vacuum = productForm.querySelector('[data-vacuum-upsell]');
        const vacuumSelected = vacuum?.querySelector('[data-vacuum-toggle]')?.checked;
        if (vacuum && vacuumSelected) {
          const variantSelect = productForm.querySelector('select[name="id"]');
          const selectedOption = variantSelect?.options?.[variantSelect.selectedIndex];
          const packetsPerItem = Math.max(1, Number(selectedOption?.dataset?.packingPackets || 1));
          const vacuumQuantity = productQuantity * packetsPerItem;
          const packingGroup = `pack-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
          productItem.properties = {
            '_Packing group': packingGroup,
            '_Packing packets per item': String(packetsPerItem)
          };
          items.push({
            id: String(vacuum.dataset.vacuumVariantId),
            quantity: vacuumQuantity,
            properties: {
              '_Packing group': packingGroup,
              '_Packing for': productForm.dataset.productTitle || 'Snack order',
              '_Packing variant': selectedOption?.textContent?.replace(/\s+/g, ' ').replace('— Sold out', '').trim() || '',
              '_Packets per item': String(packetsPerItem),
              '_Packing image': productForm.dataset.productImage || ''
            }
          });
        }
        const response = await fetch(routes.cartAdd, {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });
        const result = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(result.description || 'Unable to add these items.');
        await fetchCart();
        setDrawer('CartDrawer', true);
        button.textContent = vacuumSelected ? 'Product & packing added' : 'Added to cart';
      } catch (error) {
        button.textContent = error.message;
      } finally {
        setTimeout(() => { button.disabled = false; button.textContent = original; }, 1800);
      }
      return;
    }

    const form = event.target.closest('.js-quick-add');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    const original = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';
    try {
      const response = await fetch(routes.cartAdd, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) throw new Error('Unable to add this product.');
      await fetchCart();
      setDrawer('CartDrawer', true);
      button.textContent = 'Added';
    } catch (error) {
      button.textContent = error.message;
    } finally {
      setTimeout(() => { button.disabled = false; button.textContent = original; }, 1200);
    }
  });

  document.querySelectorAll('[data-quantity]').forEach((quantity) => {
    quantity.addEventListener('click', (event) => {
      const action = event.target.closest('[data-quantity-action]')?.dataset.quantityAction;
      const input = quantity.querySelector('input');
      if (!action || !input) return;
      const current = Number(input.value || 1);
      input.value = action === 'increase' ? current + 1 : Math.max(1, current - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  document.querySelectorAll('[data-vacuum-upsell]').forEach((vacuum) => {
    const toggle = vacuum.querySelector('[data-vacuum-toggle]');
    const details = vacuum.querySelector('[data-vacuum-details]');
    const quantity = vacuum.querySelector('[data-vacuum-quantity-input]');
    const summary = vacuum.querySelector('[data-vacuum-summary]');
    const unitPrice = Number(vacuum.dataset.vacuumPrice || 0);
    const productForm = vacuum.closest('.js-product-form');
    const productQuantity = productForm?.querySelector('input[name="quantity"]');
    const variantSelect = productForm?.querySelector('select[name="id"]');
    const updateVacuumOption = () => {
      const selected = Boolean(toggle?.checked);
      const selectedOption = variantSelect?.options?.[variantSelect.selectedIndex];
      const packetsPerItem = Math.max(1, Number(selectedOption?.dataset?.packingPackets || 1));
      const orderQuantity = Math.max(1, Number(productQuantity?.value || 1));
      const packets = Math.min(80, orderQuantity * packetsPerItem);
      if (quantity) quantity.value = String(packets);
      vacuum.classList.toggle('is-selected', selected);
      if (details) details.hidden = !selected;
      if (summary) {
        summary.hidden = !selected;
        summary.textContent = `Complete vacuum packing: ${packets} ${packets === 1 ? 'packet' : 'packets'} × ${formatMoney(unitPrice)} = ${formatMoney(unitPrice * packets)}`;
      }
    };
    toggle?.addEventListener('change', updateVacuumOption);
    productQuantity?.addEventListener('change', updateVacuumOption);
    productQuantity?.addEventListener('input', updateVacuumOption);
    variantSelect?.addEventListener('change', updateVacuumOption);
    updateVacuumOption();
  });

  document.querySelectorAll('[data-product-variants]').forEach((container) => {
    const select = container.querySelector('select[name="id"]');
    const price = document.querySelector('[data-product-price]');
    if (!select || !price) return;
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      price.textContent = formatMoney(option.dataset.price);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', select.value);
      history.replaceState({}, '', url);
    });
  });

  document.querySelectorAll('[data-gallery-thumb]').forEach((button) => {
    button.addEventListener('click', () => {
      const main = document.querySelector('[data-gallery-main]');
      if (!main) return;
      main.src = button.dataset.image;
      main.alt = button.dataset.alt || '';
      document.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => thumb.classList.remove('is-active'));
      button.classList.add('is-active');
    });
  });

  const wishlistGrid = document.querySelector('[data-wishlist-grid]');
  if (wishlistGrid) {
    const handles = getWishlist();
    if (!handles.length) {
      renderWishlistEmpty(wishlistGrid);
    } else {
      wishlistGrid.setAttribute('aria-busy', 'true');
      wishlistGrid.innerHTML = '<p class="wishlist-loading">Loading your saved snacks…</p>';
      Promise.all(handles.map(async (handle) => {
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}products/${encodeURIComponent(handle)}.js`);
          if (!response.ok) return null;
          return response.json();
        } catch (_) { return null; }
      })).then((products) => {
        const availableProducts = products.filter(Boolean);
        if (!availableProducts.length) {
          saveWishlist([]);
          renderWishlistEmpty(wishlistGrid, 'Your previously saved snacks are no longer available. Browse the menu to add new favourites.');
          refreshWishlistUI();
          return;
        }
        saveWishlist(availableProducts.map((product) => product.handle));
        wishlistGrid.innerHTML = availableProducts.map((product) => {
        const image = product.featured_image || product.images?.[0] || '';
        const variant = product.variants.find((item) => item.available) || product.variants[0];
        const displayTitle = productDisplayTitle(product.title, product.type);
        return `<article class="product-card" data-product-card data-handle="${escapeHtml(product.handle)}">
          <a class="product-card__media" href="${window.Shopify?.routes?.root || '/'}products/${encodeURIComponent(product.handle)}">${image ? `<img src="${escapeHtml(image)}&width=700" alt="${escapeHtml(displayTitle)}" loading="lazy">` : ''}</a>
          <button class="icon-button wishlist-toggle is-active" type="button" data-wishlist-toggle data-handle="${escapeHtml(product.handle)}" data-title="${escapeHtml(displayTitle)}" aria-pressed="true" aria-label="Remove ${escapeHtml(displayTitle)} from wishlist"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8l1.1 1.1L12 21l7.8-7.5 1.1-1.1a5.5 5.5 0 0 0-.1-7.8Z"></path></svg></button>
          <div class="product-card__content"><a class="product-card__title" href="${window.Shopify?.routes?.root || '/'}products/${encodeURIComponent(product.handle)}">${escapeHtml(displayTitle)}</a><div class="product-card__price">${formatMoney(product.price)}${variant?.title && variant.title !== 'Default Title' ? ` <span>· ${escapeHtml(variant.title)}</span>` : ''}</div>
          ${variant?.available ? `<form class="quick-add-form js-quick-add"><input type="hidden" name="id" value="${variant.id}"><input type="hidden" name="quantity" value="1"><button class="button button--accent button--small button--full" type="submit">Quick add</button></form>` : '<button class="button button--small" disabled>Sold out</button>'}</div></article>`;
        }).join('');
        refreshWishlistUI();
      }).finally(() => wishlistGrid.removeAttribute('aria-busy'));
    }
  }

  refreshWishlistUI();
  const savedDiscount = sessionStorage.getItem('jk-discount-code');
  const discountInput = document.querySelector('[data-cart-discount-form] input[name="discount"]');
  const discountCheckout = document.querySelector('[data-cart-checkout]');
  if (savedDiscount) {
    if (discountInput) discountInput.value = savedDiscount;
    if (discountCheckout) discountCheckout.href = `/discount/${encodeURIComponent(savedDiscount)}?redirect=/checkout`;
  }
  fetchCart().catch(() => {});
  root.classList.add('js-ready');
})();
